/* eslint-disable angular/document-service */
/* eslint-disable unicorn/prefer-query-selector */
export const groupPipelineController = ($scope, $timeout) => {
  $scope.onClickPipeline = data => {
    if (data.parentID === 'ROOT_NODE_ID' && data.selected) {
      $scope.groupList.map(row => {
        row.selected = false
        row.isActive = false
        if (row.parentID !== 'ROOT_NODE_ID') row.isHidden = true
        return row
      })
    } else if (data.selected) {
      $scope.groupList.forEach(row => {
        if (
          data.parentID !== 'ROOT_NODE_ID' &&
          data.id === row.parentID &&
          data.selected
        ) {
          if (row.hasChild && row.selected) {
            hasChildGroup(row)
          }

          data.isActive = false
          row.isHidden = true
          row.selected = false
        }
      })
      data.selected = false
    } else {
      $scope.groupList.map(row => {
        if (row.id === data.id) {
          row.selected = true
        } else {
          row.isHidden = true
          row.selected = false
        }
      })
      if (data.hasChild) {
        $scope.groupList.map(row => {
          if (row.parentID === data.id) {
            if (row.selected) {
              row.selected = false
              openCloseGroups(row)
            } else {
              data.selected = true
              data.isHidden = false
              setActiveGridItem(data)
              scrollTo(data.id)
            }

            row.isHidden = !row.isHidden
          }
        })
      } else {
        data.selected = true
        data.isHidden = false
        setActiveGridItem(data)
        scrollTo(data.id)
      }
    }

    let maxLevel = Math.max.apply(
      Math,
      $scope.groupList.map(o => {
        return o.level
      })
    )
    if (maxLevel !== data.level) {
      $scope.groupList.map(row => {
        if (
          data.selected &&
          data.parentID === 'ROOT_NODE_ID' &&
          row.parentID === 'ROOT_NODE_ID'
        ) {
          row.prevActive = false
          row.isActive = false
        }

        if (row.level > data.level && data.selected) {
          row.prevActive = false
          row.isActive = false
        }

        if (row.level === data.level && !row.selected) {
          row.isActive = false
        }
      })
    }

    let currentIndex = $scope.groupList.indexOf(data)

    let temporaryData = $scope.groupList.find(row => {
      if (
        !row.isHidden &&
        $scope.groupList.indexOf(row) > currentIndex &&
        (row.level <= data.level || (row.level === data.level && !row.level))
      )
        return row
    })
    if (maxLevel !== data.level && data.selected) {
      if (temporaryData) {
        let index = $scope.groupList.indexOf(temporaryData) - 1
        while (index) {
          if (
            !$scope.groupList[index].isHidden &&
            $scope.groupList[index].level !== maxLevel &&
            !$scope.groupList[index].selected
          ) {
            $scope.groupList[index].prevActive = true
            index = 0
          } else if (
            $scope.groupList[$scope.groupList.indexOf(temporaryData) - 1]
              .level === maxLevel &&
            !$scope.groupList[index].isHidden &&
            $scope.groupList[index].level
          ) {
            index = 0
          } else index--
        }
      }

      data.isActive = true
    }

    $timeout(() => {
      angular.element('#emptyClick').triggerHandler('click')
    }, 50)
  }

  let setActiveGridItem = item => {
    $scope.groupList.forEach(row => {
      if (item.parentID === row.parentID) row.isHidden = false
      if (row.id === item.parentID) {
        if (row.id !== 'ROOT_NODE_ID') setActiveGridItem(row)
        row.selected = true
        row.isHidden = false
      }
    })
  }

  let scrollTo = state => {
    let index = $scope.gridOptions.api
      .getModel()
      .rowsToDisplay.findIndex(row => row.id === state)
    $scope.gridOptions.api.ensureIndexVisible(index, 'top')
  }

  let openCloseGroups = data => {
    $scope.groupList.forEach(row => {
      if (row.parentID === data.id) {
        if (data.hasChild) openCloseGroups(row)
        row.selected = false
        row.isHidden = true
        return row
      }
    })
  }

  let hasChildGroup = data => {
    let dataChildren = $scope.groupList.filter(x => x.parentID === data.id)
    dataChildren.map(child => {
      if (child.hasChild && child.selected) openCloseGroups(child)
      child.selected = false
      child.isHidden = true
      return child
    })
  }

  $scope.fetchArrowStyle = color => {
    return {
      'border-top': '1px solid ' + color,
      'border-right': '1px solid ' + color,
    }
  }

  $scope.fetchActiveTab = (color, stage) => {
    let faddedColor
    faddedColor = color ? lighten(color, 60) : '#fffff'
    var activeClass = document.getElementById(stage.id)
    if (activeClass.classList.contains('active')) {
      if (stage.hasChild) {
        activeClass.style.background = '#95288f'
        activeClass.style.color = '#ffffff'
        activeClass.querySelector('.triangular-tabs').style.boxShadow =
          '1.4px -1.4px 0px 0px #ffffff'
        activeClass.querySelector('.triangular-tabs').style.borderColor =
          '#95288f #95288f transparent transparent'
      } else {
        activeClass.style.background = faddedColor
        activeClass.style.boxShadow = '8px 2px 7px 2px #ccc'
        activeClass.querySelector('.triangular-tabs').style.boxShadow =
          '1.4px -1.4px 0px 0px ' + color + ',6.4px -6.4px 6px -1px #ccc'

        activeClass.querySelector('.triangular-tabs').style.borderColor =
          faddedColor + ' ' + faddedColor + ' transparent transparent'
        activeClass.style.borderTop = '1px solid ' + color
        activeClass.style.borderBottom = '1px solid ' + color
        activeClass.style.borderRight = '0px'
        activeClass.style.borderLeft = '0px'
      }

      activeClass.querySelector('.triangular-tabs').style.borderWidth = '18px'
      activeClass.querySelector('.triangular-tabs').style.borderStyle = 'solid'
    } else {
      if (stage.hasChild) {
        activeClass.style.background = stage.color
        if (
          activeClass.style.background === 'rgb(247, 247, 247)' ||
          activeClass.style.background === 'rgb(255, 255, 255)'
        )
          activeClass.style.color = '#000000'
        else activeClass.style.color = '#ffffff'
        activeClass.querySelector(
          '.triangular-tabs'
        ).style.borderColor = `${stage.color} ${stage.color} transparent transparent`
        activeClass.querySelector('.triangular-tabs').style.boxShadow =
          '1.4px -1.4px 0px 0px  #ffffff'
      } else {
        activeClass.style.background = 'transparent'
        activeClass.querySelector('.triangular-tabs').style.borderColor =
          'white white transparent transparent'
        activeClass.querySelector('.triangular-tabs').style.boxShadow =
          '1.4px -1.4px 0px 0px ' + color
        activeClass.style.borderTop = '1px solid ' + color
        activeClass.style.borderBottom = '1px solid ' + color
        activeClass.style.borderRight = '0px'
        activeClass.style.borderLeft = '0px'
      }

      activeClass.querySelector('.triangular-tabs').style.borderWidth = '18px'
      activeClass.querySelector('.triangular-tabs').style.borderStyle = 'solid'
    }
  }
}

const addLight = (color, amount) => {
  let cc = Number.parseInt(color, 16) + amount
  let c = cc > 255 ? 255 : cc
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
  return c
}

const lighten = (color, amount) => {
  color = color.includes('#') ? color.slice(1, color.length) : color
  amount = Number((255 * amount) / 100)
  color = `#${addLight(color.slice(0, 2), amount)}${addLight(
    color.slice(2, 4),
    amount
  )}${addLight(color.slice(4, 6), amount)}`
  return color
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/group-pipeline/controller.js